import classnames from "classnames";
import PurchasePlanModal from "components/PurchasePlanModal";
import { routes } from "pages/routes";
import { ReactElement, ReactPortal, useState } from "react";
import { Navigate } from "react-router";
import { PurchaseStudentType } from "services/pricingModel/model";
import { isSelfStudyUser } from "services/users/utils";
import { useUser } from "../../contexts/UserContext";

type Props = {
  onSuccess?: () => void;
  children?: React.ReactNode;
  triggerContainerClassName?: string;
  onUpgrade?: () => void;
  enable?: boolean;
  onClose?: () => void;
  onError?: () => void;
  dialogPortal?: (children: ReactElement) => ReactPortal;
  defaultOpen?: boolean;
  type?: PurchaseStudentType;
};

export default function Paywall({ type = "self-study", ...props }: Props) {
  const user = useUser();
  const [isModalOpen, setModalOpen] = useState(false);

  // If defaultOpen is undefined or false - we must look at the locally stored "open" state.
  const shouldOpen = props.defaultOpen === true ? true : isModalOpen;

  const hdClose = () => {
    setModalOpen(false);
    props.onClose?.();
  };

  const onSuccess = () => {
    setModalOpen(false);
    props.onSuccess?.();
  };

  const onOpen = () => {
    setModalOpen(true);
  };

  let modalElement;
  if (!isSelfStudyUser(user) || user.company) {
    modalElement = <Navigate to={routes.settingsBilling.path()} />;
  } else {
    modalElement = (
      <PurchasePlanModal onClose={hdClose} onSuccess={onSuccess} type={type} />
    );
    if (props.dialogPortal) {
      modalElement = props.dialogPortal(modalElement);
    }
  }

  return (
    <>
      <div
        className={classnames("trigger-modal-container", props.triggerContainerClassName)}
        onClick={props.enable ? onOpen : undefined}
      >
        {props.children}
      </div>

      {shouldOpen && modalElement}
    </>
  );
}
